import {
    Report,
    Template,
    Timesheet,
    TimesheetTemplate,
    Type,
} from 'api/report/types';

export type TimesheetReportTemplate = Template & {
    type: Type.TIMESHEET;
    data: TimesheetTemplate;
};

export type TimesheetReport = Report & {
    template: TimesheetReportTemplate;
    data: Timesheet;
};

export function isTimesheetReport(report: Report): report is TimesheetReport {
    return report.template.type === Type.TIMESHEET;
}
